export default {
    "fr": [],
    "en": []
}
